import type { CollectionSummaryJSONObject } from '@ikegps/core-api';
import type { IkeRestDepartment } from '../rest.department';
import { IkeRestObject } from './base';

export class IkeObjectCollectionSummary extends IkeRestObject<CollectionSummaryJSONObject> {
	className = 'CollectionSummary' as const;
	actionName = 'collection.summary';
	object: CollectionSummaryJSONObject;

	constructor() {
		super();
		this.cacheKeys['uuid'] = true;
		this.cacheKeys['revision'] = true;
		this.cacheKeys['collectionId'] = true;
	}

	override updateCache<K extends keyof CollectionSummaryJSONObject>(
		key: K,
		result: CollectionSummaryJSONObject,
		rest: IkeRestDepartment
	) {
		super.updateCache(key, result, rest);

		this.cacheIfLatest('uuid', result, rest);
		this.cacheIfLatest('revision', result, rest);
		this.cacheIfLatest('collectionId', result, rest);
	}
}
